function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.39384 13.0809L6.99992 12.912L6.606 13.0809L1.58325 15.2335V2.08333C1.58325 1.62728 1.96054 1.25 2.41659 1.25H11.5833C12.0393 1.25 12.4166 1.62728 12.4166 2.08333V15.2335L7.39384 13.0809Z",
  stroke: "currentColor",
  strokeWidth: 2
});
function SvgWatchlistThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchlistThick);
export default __webpack_public_path__ + "static/media/watchlist-thick.adce96ce.svg";
export { ForwardRef as ReactComponent };